import AxiosUserist from "./AxiosUserist";

class ModelUserist {

  constructor(resource) {
    this.resource = resource;
  }

  get() {
    return AxiosUserist.get(`${this.resource}`)
  }

  getId(id) {
    // FIXME There should be no "?id=" here
    // return AxiosUserist.get(`${this.resource}/${id}/`); // FIXME There should be no "?id=" here
    return AxiosUserist.get(`${this.resource}/?id=${id}`)
  }

  getParams(params) {
    return AxiosUserist.get(`${this.resource}`, { params: params })
  }

  create(params) {
    return AxiosUserist.post(`${this.resource}/`, params);
  }

  update(id, params) {
    return AxiosUserist.put(`${this.resource}/${id}/`, params);
  }

  delete(id) {
    return AxiosUserist.delete(`${this.resource}/${id}`);
  }

}


export default ModelUserist;
